<div class="online-hours-card">
    <div class="oh-header">
        <div class="oh-title-group">
            <h3 class="oh-title">{{ "ONLINE_HOURS" | translate }}</h3>
            <p class="oh-subtitle">{{ "ONLINE_HOURS_SUBTITLE" | translate }}</p>
        </div>
        <div class="oh-controls">
            <div class="range-tabs">
                <button type="button" *ngFor="let r of ranges" [class.active]="activeRange === r"
                    [disabled]="isDisabled(r)" (click)="selectRange(r)">{{ r }}</button>
            </div>
        </div>
    </div>
</div>

<ng-content></ng-content>

<div class="online-hours-card">
    <div class="oh-slot-size-row">
        <span class="slot-size">{{ "ONE_SLOT_EQUALS" | translate }} {{ slotSizeLabel }}</span>
    </div>

    <div class="oh-bar" [style.grid-template-columns]="barGridTemplateColumns" (mouseleave)="onBarMouseLeave()">
        <div class="oh-cell" *ngFor="let slot of slots; let i = index" [ngClass]="slot.status"
            [style.grid-column]="2 * i + 1" (mouseenter)="onCellMouseEnter(i)">
            <!-- both anchored to THIS cell's own left edge - no separate positioning to keep
                 in sync, so they can never drift apart from it or from each other -->
            <span class="boundary-marker start" *ngIf="slot.startLabel.length" [class.edge]="i === 0">
                <span class="tick"></span>
                <span class="label">
                    <span class="label-line" *ngFor="let line of slot.startLabel">{{ line }}</span>
                </span>
            </span>
            <span class="crosshair" *ngIf="hoveredSlotIndex === i">
                <span class="crosshair-label" [class.align-right]="i === slots.length - 1">{{ hoveredSlotLabel }}</span>
            </span>
        </div>

        <!-- the one boundary with no slot to start - the end of the last slot - anchored to
             the last cell's own right edge instead -->
        <span class="boundary-marker end" *ngIf="lastSlotEndLabel.length">
            <span class="tick"></span>
            <span class="label">
                <span class="label-line" *ngFor="let line of lastSlotEndLabel">{{ line }}</span>
            </span>
        </span>
    </div>

    <div class="oh-footer">
        <div class="legend">
            <span class="legend-item"><span class="dot online"></span>{{ "ONLINE" | translate }}</span>
            <span class="legend-item"><span class="dot offline"></span>{{ "OFFLINE" | translate }}</span>
        </div>
        <div class="current-time">{{ "CURRENT_TIME" | translate }}: {{ currentTime }}</div>
    </div>
</div>
